let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("88n0M")).then(() => parcelRequire('l8NK5'));